import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Licenses", -1)
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Edit ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.licenses)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          value: _ctx.licenses
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "title",
              header: "Title"
            }),
            _createVNode(_component_Column, {
              field: "selectable",
              header: "Selectable"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.selectable ? 'Yes' : 'No'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Actions",
              class: "actions-column"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_router_link, {
                    class: "p-button",
                    to: _ctx.editRoute(slotProps.data.id)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true)
  ], 64))
}